import { createSupabaseBrowserClient } from '@/lib/supabase/client';

export type ActionResult = { ok: boolean; error?: string };

export async function submitContact(input: {
  full_name: string;
  email: string;
  phone?: string;
  subject?: string;
  message: string;
  locale: string;
}): Promise<ActionResult> {
  if (!input.full_name || !input.email || !input.message) {
    return { ok: false, error: 'missing_fields' };
  }
  const supabase = createSupabaseBrowserClient();
  const { error } = await supabase.from('contact_submissions').insert({
    full_name: input.full_name,
    email: input.email,
    phone: input.phone ?? '',
    subject: input.subject ?? '',
    message: input.message,
    locale: input.locale,
  });
  if (error) return { ok: false, error: error.message };
  return { ok: true };
}

export async function submitForensic(input: {
  requester_name: string;
  institution?: string;
  court_case?: string;
  request_type?: string;
  email: string;
  phone?: string;
  message: string;
  locale: string;
}): Promise<ActionResult> {
  if (!input.requester_name || !input.email || !input.message) {
    return { ok: false, error: 'missing_fields' };
  }
  const supabase = createSupabaseBrowserClient();
  const { error } = await supabase.from('forensic_requests').insert({
    requester_name: input.requester_name,
    institution: input.institution ?? '',
    court_case: input.court_case ?? '',
    request_type: input.request_type ?? '',
    email: input.email,
    phone: input.phone ?? '',
    message: input.message,
    locale: input.locale,
  });
  if (error) return { ok: false, error: error.message };
  return { ok: true };
}
